// Customer link tracking helpers shared by the dashboard and share panel.
export function timeAgo(iso) {
  if (!iso) return '';
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`;
  return new Date(iso).toLocaleDateString('en-GB');
}

export const HOT_VIEWS = 3;

// 'decided' | 'hot' | 'seen' | 'unseen' (sent, not opened) | 'unsent'
export function trackingState(p) {
  if (p.share_decision_at || ['accepted', 'declined', 'paid'].includes(p.status)) return 'decided';
  const views = p.share_views || 0;
  if (views >= HOT_VIEWS) return 'hot';
  if (views > 0) return 'seen';
  if (p.share_sent_at || p.status === 'sent') return 'unseen';
  return 'unsent';
}

export const TRACK_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'unsent', label: 'Not sent yet' },
  { id: 'unseen', label: 'Sent · not seen' },
  { id: 'seen', label: 'Seen' },
  { id: 'hot', label: 'Hot leads' },
];

export function matchesTrack(p, filter) {
  if (filter === 'all') return true;
  const st = trackingState(p);
  if (filter === 'seen') return st === 'seen' || st === 'hot';
  return st === filter;
}
